module.exports = {"gender":{"male":97,"female":25},"provider_type":{"psychologist":44,"psychiatrist":29},"call_channel":{"phone":60,"web":9},"tag":{"Depression":{"id":20,"count":12}},"returning":{"time3":44,"time6+":4},"patient_feedback":{"good":23,"bad":11,"null":73},"provider_feedback":{"good":54,"bad":22,"null":56},"Department":[{"id":-1,"count":11},{"id":92,"count":46},{"id":91,"count":21}],"NewOOCAAttr":[{"id":-1,"count":97},{"id":90,"count":1}],"PHA":[{"id":-1,"count":18}]}


//////////////////
// WEBPACK FOOTER
// ./src/_mockup/counseling_report_select_1.json
// module id = 1879
// module chunks = 0